export class TipoCaixaModel {
  id: number;
  descricao: String;
  cor: String;
}



// WEBPACK FOOTER //
// /app/src/app/model/caixa/tipocaixa.model.ts